export default __webpack_public_path__ + "static/pimg3-8bd4ee946e94549e2281e88eca33f485.jpg";